import { Text } from "@mantine/core"
import { useTranslation } from "react-i18next"

/** Exception type as bold plain text (no coloured fill or border). */
export function InboundExceptionTypeBadge({ exceptionType }: Readonly<{ exceptionType: string | null | undefined }>) {
  const { t } = useTranslation("inbound")
  if (!exceptionType) return <Text span>-</Text>
  return (
    <Text span fz={16} fw={700}>
      {t(`exceptionType.${exceptionType}`, { defaultValue: "-" })}
    </Text>
  )
}
